<template>
  <div class="relative" @mousedown="trackClick">
    <div v-if="$store.state.activeUser.length <= 0"></div>
    <div
      class="w-full relative"
      v-else-if="$store.state.activeUser.role != 'temp'"
    >
      <div
        ref="changelog"
        class="w-full expandable bg-yellow-400 bg-opacity-50 text-sky-900 underline z-50 text-center text-sm"
      >
        <router-link to="/changelog"
          >What's new in {{ "v" + $version }}</router-link
        >
      </div>
      <div class="w-full flex relative">
        <nav
          id="sa-nav-drawer"
          class="nav"
          :class="{ 'nav-open': drawerOpen }"
          :aria-hidden="a11y.ariaHidden"
        >
          <!-- Only the drawer shows this; at 1280px and up the sidebar has the
               page's own header above it and needs neither title nor close. -->
          <div class="nav-head">
            <span class="nav-title">Subangstrom Inventory</span>
            <button
              ref="drawerClose"
              type="button"
              class="nav-close"
              aria-label="Close menu"
              @click="closeNav"
            >
              <!-- Inline SVG, not the icon font: on a phone the remote font can arrive
                   late or never, and the ligature text "close" showed instead. -->
              <svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>
            </button>
          </div>

          <ul
            class="cursor-pointer flex-1 w-full sticky top-0"
            @click="closeNav"
          >
            <router-link to="/home"><li>Home</li></router-link>
            <router-link to="/my-profile"><li>My Profile</li></router-link>
            <router-link to="/manage-products"
              ><li>Manage Products</li></router-link
            >
            <router-link
              v-if="$store.state.activeUser?.role == 'lab-admin'"
              to="/shared-products"
              ><li>Shared Products</li></router-link
            >
            <router-link
              v-if="$store.state.activeUser?.role == 'lab-admin'"
              to="/transport-racks"
              ><li>Transport Racks</li></router-link
            >
            <router-link
              v-if="$store.state.activeUser?.role == 'lab-admin'"
              to="/group-admin-page"
              ><li>Group Admin Page</li></router-link
            >
            <router-link
              v-if="$store.state.activeUser?.role == 'lab-admin'"
              to="/project-manager"
              ><li>Project Manager</li></router-link
            >
            <router-link to="/team-members"><li>Team Members</li></router-link>

            <router-link to="/archives"><li>Grid Explorer</li></router-link>
            <!-- Same rule the voice button applies to itself: a lab outside the
                 invite-only beta is shown nothing, rather than a link that leads
                 to a page explaining it cannot have the feature. Gated on the
                 populated lab (userModel selects '-__v', so voiceBeta is already
                 here) rather than on fetched credits — the credits call is made
                 by this page and the voice button, so gating on it would hide
                 the only link that reaches the page that fetches it. -->
            <router-link
              v-if="$store.state.activeUser?.labId?.voiceBeta"
              to="/voice-credits"
              ><li>Voice Minutes</li></router-link
            >
            <router-link
              v-if="$store.state.activeUser?.role == 'lab-admin'"
              to="/data-settings"
              ><li>Data Settings</li></router-link
            >
            <router-link v-if="$store.state.isMark" to="/admin">
              <li class="text-orange-500">Administrative</li></router-link
            >
            <!-- Same gate as the link above it, because it is the same
                 privilege: the route behind it is guarded on `isMark` and the
                 endpoints behind that are `restrictTo('mark')`. -->
            <router-link v-if="$store.state.isMark" to="/admin/voice">
              <li class="text-orange-500">Voice Usage</li></router-link
            >
          </ul>
        </nav>
        <div
          class="nav-scrim"
          :class="{ 'nav-scrim-open': drawerOpen }"
          aria-hidden="true"
          @click="closeNav"
        ></div>
        <main>
          <div
            ref="toprowid"
            id="toprow"
            class="pb-4 pt-1 flex items-center sticky bg-white"
            style="top: 0; z-index: 49"
          >
            <div class="flex-1 ml-1 flex">
              <div class="mr-1 xl:hidden mx-0 my-auto flex-none">
                <button
                  ref="hamburger"
                  type="button"
                  class="nav-toggle"
                  aria-label="Open menu"
                  aria-controls="sa-nav-drawer"
                  :aria-expanded="a11y.ariaExpanded"
                  @click="toggleNav"
                >
                  <!-- Inline SVG for the same reason as the close button. -->
                  <svg aria-hidden="true" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M4 7h16M4 12h16M4 17h16"/></svg>
                </button>
              </div>

              <div class="flex-initial">
                <img
                  alt="Subangstrom"
                  src="https://d1muf25xaso8hp.cloudfront.net/https%3A%2F%2Fs3.amazonaws.com%2Fappforest_uf%2Ff1577048235134x219865190081106400%2Fsubangstrom-medium.png?w=192&h=77&auto=compress&fit=crop&dpr=1.25"
                />
              </div>
            </div>

            <div class="mr-2">
              <div
                class="text-green-800 text-xs font-bold text-right my-1 block"
              >
                Hi {{ $store.state.activeUser?.name?.split(" ")[0] }}
              </div>
              <div class="flex justify-between items-end relative">
                <i
                  @click="setPage('messages')"
                  class="fas fa-envelope text-2xl text-sky-900 mr-3 cursor-pointer hover:text-green-800"
                ></i>
                <!-- <i
                  @click="setPage('my-profile')"
                  class="fas fa-user-circle text-2xl text-sky-900 mr-3 cursor-pointer hover:text-green-800"
                ></i> -->
                <span
                  v-if="
                    $store.state.activeUser.superLabIds &&
                    $store.state.activeUser.superLabIds.length > 0
                  "
                  ><select
                    style="margin: 0"
                    @change="switchLab($event)"
                    class="w-[max-content]"
                  >
                    <option
                      :key="labId._id"
                      :selected="
                        $store.state.activeUser.activeLabId?._id === labId._id
                      "
                      :value="labId._id"
                      v-for="labId in $store.state.activeUser.superLabIds"
                    >
                      {{ labId.name }}
                    </option>
                  </select></span
                >
                <span
                  @click="setPage('my-profile')"
                  class="material-symbols-outlined text-2xl text-sky-900 leading-none mx-3 cursor-pointer hover:text-green-800 relative"
                >
                  account_circle
                </span>

                <button
                  @click="$store.dispatch('logout')"
                  class="logoutbtn text-xs px-2"
                  style="margin: 0"
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
          <div class="flex-1 justify-center w-full">
            <router-view
              :change-page="setPage"
              @openfeedback="showFeedback = true"
            ></router-view>
            <!-- <component :change-page="changeSelectedPage" :is="selectedPage" /> -->
          </div>
          <div
            class="bg-sky-900 invisible z-10 text-white text-center text-sm py-3 relative bottom-0 w-full mt-8"
          >
            inventory.subangstrom.com - All Rights Reserved
            <!--space holder-->
          </div>
          <div
            class="bg-sky-900 z-20 text-white text-center text-sm py-3 absolute bottom-0 left-0 w-full mt-8"
          >
            inventory.subangstrom.com - All Rights Reserved
            <div class="absolute bottom-0 right-0 text-xs text-gray-400 mr-2">
              {{ "v" + $version }}
            </div>
          </div>
        </main>
      </div>
    </div>
    <div class="w-screen h-screen flex items-center justify-center" v-else>
      <div class="inline-block m-auto">
        Your account is awaiting approval from your lab's administrator. You
        will receive an email notification once approved.
      </div>
    </div>

    <display-modal v-if="showFeedback" @ridfeedback="ridFeedback">
      <feedback-inner></feedback-inner>
    </display-modal>
  </div>
</template>

<script>
import FeedbackInner from "./modal-inners/feedback-inner.vue";
// import ManageProducts from './router-pages/loggedin/ManageProducts.vue';
// import MyProfile from './router-pages/loggedin/MyProfile.vue';
// import Messages from './router-pages/loggedin/Messages.vue';
// import SharedProducts from './router-pages/loggedin/SharedProducts.vue';
// import TeamMembers from './router-pages/loggedin/TeamMembers.vue';
// import ProjectManager from './router-pages/loggedin/ProjectManager.vue';
// import TransportRacks from './router-pages/loggedin/TransportRacks.vue';
// import GroupAdminPage from './router-pages/loggedin/GroupAdminPage.vue';
import {
  ref,
  provide,
  onMounted,
  onBeforeUnmount,
  nextTick,
  watch,
  computed,
} from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";

/**
 * Below this width the nav is a drawer over the page; at it and above, the
 * static sidebar. One number, shared by the media queries below and by the
 * matchMedia this component listens to, so the two cannot drift apart.
 */
export const DRAWER_BREAKPOINT = 1280;

/** Put on <body> while the drawer holds the screen, so the page cannot scroll. */
export const BODY_LOCK_CLASS = "sa-nav-locked";

/**
 * Every consequence of the drawer being open, decided in one place.
 *
 * The drawer used to be steered by writing `style.transform`, `style.display`,
 * `style.position` and `style.zIndex` straight onto the element, which is why
 * nothing could be asserted about it without a browser. These are the same
 * decisions as plain data: what the hamburger reports, whether the nav is
 * hidden from assistive technology, whether the page is frozen behind it, and
 * where focus belongs afterwards.
 *
 * `narrow` defaults to true because that is the only width at which the drawer
 * exists at all. It matters for one answer: at 1280px and up the nav is the
 * page's permanent sidebar, so it must NOT be reported as hidden just because
 * no drawer is open.
 */
export function drawerA11y({ open, narrow = true } = {}) {
  const isOpen = !!open && !!narrow;
  return {
    open: isOpen,
    ariaExpanded: isOpen ? "true" : "false",
    ariaHidden: narrow ? (isOpen ? "false" : "true") : null,
    lockScroll: isOpen,
    bodyClass: BODY_LOCK_CLASS,
    scrim: isOpen,
    focus: isOpen ? "close" : "hamburger",
  };
}

export default {
  components: { FeedbackInner },
  props: [],

  methods: {
    switchLab(event) {
      const selectedLabId = event.target.value;
      const url =
        this.$store.state.hostname + "/api/v1/users/switchlab/" + selectedLabId;
      const request = new Request(url, {
        credentials: "include",
        method: "GET",
      });
      fetch(request)
        .then((resp) => resp.json())
        .then((data) => {
          if (data.status == "fail") throw new Error(data.message);
          else {
            window.location.reload();
            // console.log(data.data.data);
            //context.commit("updateUserData", { value: data.data.data });
            //arrayOfDewars.value = data.data.data;
          }
        })
        .catch((err) => console.log(err));
    },
    trackClick(ev) {
      // The drawer is a modal surface. This handler exists to put the caret
      // back in the search bar after a stray click, and on the two pages that
      // want it, it fires 100ms after ANY mousedown — including the one that
      // opened the drawer, which is how it used to steal focus straight back
      // out of the drawer's close button.
      if (this.drawerOpen) return;
      console.log("mouse down on", ev.target, this.$route);
      if (
        (this.$route.name == "home" || this.$route.name == "manage-products") &&
        !this.$store.state.importModalMounted
      ) {
        if (
          ev.target instanceof HTMLInputElement ||
          ev.target instanceof HTMLTextAreaElement ||
          ev.target instanceof HTMLSelectElement
        )
          console.log("input clicked");
        else
          window.setTimeout(() => {
            // Checked again here, not just on the way in: this runs 100ms after
            // mousedown, and the mousedown that opens the drawer is dispatched
            // before the click that opens it. At entry the drawer is still
            // closed; by the time this fires it is open and holding focus.
            if (this.drawerOpen) return;
            if (document.getElementById("searchbarforloggedin"))
              document.getElementById("searchbarforloggedin").focus();
          }, 100);
      }
    },
  },

  setup() {
    const store = useStore();
    const boxColors = store.state.boxColors;
    const transformBoxColor = store.state.transformBoxColor;
    const selectedPage = ref("home");
    const toprowid = ref(null);
    const changelog = ref(null);
    const hamburger = ref(null);
    const drawerClose = ref(null);
    const drawerOpen = ref(false);
    // Assume the drawer width until `matchMedia` answers on mount: a nav that
    // starts life hidden from assistive technology and is then revealed is the
    // safe way round, and on a phone it is also the true one.
    const isNarrow = ref(true);
    const a11y = computed(() =>
      drawerA11y({ open: drawerOpen.value, narrow: isNarrow.value })
    );
    const router = useRouter();
    const route = useRoute();
    const showFeedback = ref(false);
    const feedbackElem = ref(null);
    const userEmail = computed(() => {
      return store.state.activeUser?.email;
    });

    watch(userEmail, (newVal) => {
      if (newVal) {
        // Assuming you might need a delay, use setTimeout here
        setTimeout(() => {
          searchheightfix();
        }, 500); // Adjust the delay as needed
      }
    });
    const topRowHeight = ref("0px");
    provide("topRowHeight", topRowHeight);

    function searchheightfix() {
      const stupidinterval = setTimeout(() => {
        if (changelog.value) changelog.value.classList.add("giveheight");

        function outerHeight(el) {
          var height = el.offsetHeight;
          var style = getComputedStyle(el);

          height += parseInt(style.marginTop) + parseInt(style.marginBottom);
          return height;
        }

        if (toprowid.value) {
          console.log(outerHeight(toprowid.value) + "px");
          topRowHeight.value = outerHeight(toprowid.value) + "px";
          // console.log((toprowheight.value = this.topRowHeight.value));
          clearTimeout(stupidinterval);
        }
      }, 500);
    }

    // function changeSelectedPage(pageName) {
    //   selectedPage.value = pageName;
    // }

    function setPage(pagename) {
      router.push({ name: pagename });
    }

    function ridFeedback() {
      showFeedback.value = false;
    }

    function openNav() {
      if (!isNarrow.value || drawerOpen.value) return;
      drawerOpen.value = true;
      // The close button is the first thing a keyboard or screen-reader user
      // needs, and moving focus into the drawer is also what stops Tab from
      // walking the page behind it.
      nextTick(() => drawerClose.value && drawerClose.value.focus());
    }

    /**
     * Close it. `restoreFocus` is false when the drawer is closing because
     * something else already moved on — a route change, or a resize into the
     * desktop sidebar — since pulling focus back to a hamburger the user never
     * touched would be the rudest thing this component could do.
     */
    function closeNav(opts) {
      if (!drawerOpen.value) return;
      drawerOpen.value = false;
      if (!opts || opts.restoreFocus !== false)
        nextTick(() => hamburger.value && hamburger.value.focus());
    }

    function toggleNav() {
      if (drawerOpen.value) closeNav();
      else openNav();
    }

    function onDocumentKeydown(ev) {
      if (ev.key === "Escape" && drawerOpen.value) closeNav();
    }

    let drawerMedia = null;

    function onDrawerMediaChange(ev) {
      isNarrow.value = ev.matches;
      // Grown past the breakpoint: the nav is the sidebar again, so the scrim
      // and the body lock have to go with the drawer.
      if (!ev.matches) closeNav({ restoreFocus: false });
    }

    let lockedScrollY = 0;

    // One watcher owns the body class, so open, close, route change and resize
    // cannot each leave their own half-applied version of the lock behind.
    watch(
      () => a11y.value.lockScroll,
      (lock) => {
        if (typeof document === "undefined") return;
        if (lock) {
          lockedScrollY = window.scrollY;
          document.body.classList.add(BODY_LOCK_CLASS);
        } else if (document.body.classList.contains(BODY_LOCK_CLASS)) {
          document.body.classList.remove(BODY_LOCK_CLASS);
          // `overflow: hidden` clips the page to a shorter scroll range, so a
          // page that was near the bottom gets nudged up while the drawer is
          // over it. Measured at 390x844: 240px in, 262px back. Put it back.
          window.scrollTo(0, lockedScrollY);
        }
      }
    );

    watch(
      () => route.fullPath,
      () => closeNav({ restoreFocus: false })
    );

    onMounted(() => {
      searchheightfix();
      window.addEventListener("resize", searchheightfix);
      addCssForBoxColors();

      drawerMedia = window.matchMedia(
        "(max-width: " + (DRAWER_BREAKPOINT - 1) + "px)"
      );
      isNarrow.value = drawerMedia.matches;
      if (drawerMedia.addEventListener)
        drawerMedia.addEventListener("change", onDrawerMediaChange);
      else drawerMedia.addListener(onDrawerMediaChange);
      document.addEventListener("keydown", onDocumentKeydown);
    });

    onBeforeUnmount(() => {
      window.removeEventListener("resize", searchheightfix);
      document.removeEventListener("keydown", onDocumentKeydown);
      if (drawerMedia) {
        if (drawerMedia.removeEventListener)
          drawerMedia.removeEventListener("change", onDrawerMediaChange);
        else drawerMedia.removeListener(onDrawerMediaChange);
      }
      // A component that unmounts while the drawer is open must not leave the
      // page frozen behind it.
      document.body.classList.remove(BODY_LOCK_CLASS);
    });

    function addCssForBoxColors() {
      if (!document.getElementById("singletonBoxColors")) {
        const styleElem = document.createElement("style");
        document.head.append(styleElem);
        let css = "";
        styleElem.id = "singletonBoxColors";
        styleElem.type = "text/css";

        boxColors.forEach((color, index) => {
          if (color == "white") {
            css += `.graycircle-${index} {fill: ${transformBoxColor(
              "white",
              true
            )};}`;

            css += `.boxChoice-color-${index}.clip .st0 {
                                       stroke:${transformBoxColor(
                                         color,
                                         true
                                       )};}`;

            css += `.boxChoice-color-${index} .st2 {stroke:${transformBoxColor(
              color,
              true
            )};}`;
          } else {
            css += `.graycircle-${index} {

            fill: ${transformBoxColor(color)};}`;
          }

          css += `.boxChoice-color-${index}.clip .st3 {
                                  fill: none;
                                }`;

          css += `.boxChoice-color-${index}.clip .st0 {

                                 fill: ${transformBoxColor(color)} !important;
                                 }`;
          css += `.boxChoice-color-${index}.unclip .st0 {

                                                    fill: ${transformBoxColor(
                                                      color,
                                                      true
                                                    )} !important;

                         }`;
          css += `.boxChoice-color-${index}.unclip .st1 {

                                                    fill: ${transformBoxColor(
                                                      color
                                                    )} !important;

                         }`;

          css += `.boxChoice-color-${index}.clip .st1 {fill: ${transformBoxColor(
            color,
            true
          )} !important;}`;

          css += `.boxChoice-color-${index} .st2 {

                         fill: #ffffff !important;
                         }`;

          css += `.boxChoice-color-${index} .stblack {

                         fill: #000000 !important;
                         }`;
          css += `.boxChoice-color-${index}.unclip .st3 {
   fill: url(#SVGID_PLUSSIGN) !important;
                             stroke: #ffffff;
                             stroke-width: 0.25;
                             stroke-miterlimit: 10;
                         }`;
        });

        boxColors.forEach((color) => {
          if (color == "white") {
            css += `.well-white-clipped .st2 {
           stroke:${transformBoxColor(color, true)} !important;}`;
          }

          css += `.well-${color.replace(/\s+/g, "-")}-clipped .st0 {
        fill:${transformBoxColor(color)} !important;
        }
        .well-${color.replace(/\s+/g, "-")}-clipped .st1 {
        fill:${transformBoxColor(color, true)} !important;
        }

        `;
        });

        boxColors.forEach((color) => {
          if (color == "white") {
            css += `.well-white-unclipped .st2 {
           stroke:${transformBoxColor(color, true)} !important;}`;
          }
          css += `.well-${color.replace(/\s+/g, "-")}-unclipped .st0 {
        fill:${transformBoxColor(color, true)} !important;
        }
        .well-${color.replace(/\s+/g, "-")}-unclipped .st1 {
        fill:${transformBoxColor(color)} !important;
        }

        `;
        });

        if (styleElem.styleSheet) {
          // This is required for IE8 and below.
          styleElem.styleSheet.cssText = css;
        } else {
          styleElem.appendChild(document.createTextNode(css));
        }
      }
    }

    return {
      selectedPage,
      showFeedback,
      topRowHeight,
      toprowid,
      addCssForBoxColors,
      ridFeedback,
      setPage,
      changelog,
      feedbackElem,
      drawerOpen,
      a11y,
      hamburger,
      drawerClose,
      openNav,
      closeNav,
      toggleNav,
    };
  },
};
</script>
<style scoped>
.expandable {
  overflow: hidden;

  line-height: 0;
  transition: all 0.5s ease-in-out;
}

.giveheight {
  line-height: 1.5;
}

.logoutbtn {
  padding: 0.1rem 0.4rem;
}

a:visited :not(.expandable) {
  color: white;
}

button {
  margin: auto;
  cursor: pointer;
  background: none rgba(51, 92, 139);
  border: 2px solid rgba(47, 83, 125);

  text-align: center;
  margin-bottom: 1rem;
  min-height: min-content;
  max-height: 39px;
  height: 6vh;
  max-width: 162px;
  width: 100%;
  color: rgb(255, 255, 255);

  font-family: Montserrat;
  border-radius: 26px;
}

#toprow {
  min-height: min-content;
  width: 100%;
}
#toprow img {
  max-height: 60px;
  width: auto;
}

nav {
  width: 25%;
  max-width: 300px;
  color: white;
  background: rgb(5, 46, 77);
  min-height: 100vh;
}

li:hover {
  background: #097021;
}
li {
  padding: 1rem 0rem 1rem 1rem;
  border: solid 1px rgba(255, 255, 255, 0.1);
  border-width: 1px 0 0 0;
}

button {
  border-radius: 0;
  min-height: 0;
  height: auto;
}

main {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;

  align-items: flex-start;
  position: relative;
  top: 0;
  left: 0;
}

/* ====================================================== the drawer, < 1280px
 *
 * Nothing here is a new colour. The panel is the sidebar's own navy, the
 * header is one step darker so it reads as a shelf rather than a banner, the
 * hairline is the same rgba(255,255,255,.1) the list items already draw, and
 * the only accent is the #097021 the list has always used on hover.
 */

@media (min-width: 1280px) {
  /* The sidebar is permanent furniture: it needs neither a title bar nor a
     way to dismiss it, and there is nothing to dim. */
  .nav-head,
  .nav-scrim {
    display: none;
  }
}

@media (max-width: 1279px) {
  nav {
    position: fixed;
    inset: 0 auto 0 0;
    /* Over the voice dock (9500) and the inline voice control (8900), which are
       fixed too and would otherwise sit on top of the scrim; under the app's
       notifications (10000), which should still be able to speak. */
    z-index: 9800;
    width: min(84vw, 320px);
    max-width: none;
    /* `dvh`, not `vh`: on a phone `100vh` is taller than the visible page, and
       that difference is exactly what used to push the last three links under
       the browser chrome where nothing could reach them. */
    height: 100dvh;
    min-height: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    padding-top: env(safe-area-inset-top, 0px);
    padding-right: env(safe-area-inset-right, 0px);
    padding-bottom: env(safe-area-inset-bottom, 0px);
    padding-left: env(safe-area-inset-left, 0px);
    box-shadow: 0 0 2.5rem rgba(0, 0, 0, 0.45);
    transform: translateX(-100%);
    /* `visibility` is what keeps the closed drawer out of the tab order and
       out of the accessibility tree; it is held until the slide finishes so
       the drawer is still on screen while it leaves. */
    visibility: hidden;
    transition: transform 200ms ease-out, visibility 0s linear 200ms;
  }

  nav.nav-open {
    transform: translateX(0);
    visibility: visible;
    transition: transform 200ms ease-out, visibility 0s;
  }

  /* The drawer itself scrolls, so the list must not also try to stick. */
  nav ul {
    position: static;
  }

  .nav-head {
    display: flex;
    position: sticky;
    top: 0;
    z-index: 1;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    padding: 0.5rem 0.5rem 0.5rem 1rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.14);
    background: rgb(3, 32, 54);
  }

  .nav-title {
    overflow: hidden;
    /* The one face this app reserves for its own chrome, already on every
       button in this component. */
    font-family: Montserrat, ui-sans-serif, system-ui, sans-serif;
    font-size: 0.95rem;
    font-weight: 600;
    color: #ffffff;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .nav-close {
    display: flex;
    flex: none;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    min-height: 44px;
    max-width: none;
    max-height: none;
    margin: 0;
    padding: 0;
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-radius: 0.25rem;
    background: none rgba(255, 255, 255, 0.08);
    color: #ffffff;
    /* The blanket `button` rule in this component sets `font-family: Montserrat`
       at a specificity the global `.material-symbols-outlined` class cannot
       beat, so a button carrying an icon name renders the word instead of the
       glyph. Naming the face here is what keeps it an icon. */
    font-size: 1.5rem;
    line-height: 1;
  }

  .nav-close:hover {
    border-color: #097021;
    background: none #097021;
  }

  .nav-close:focus-visible {
    outline: 2px solid #ffffff;
    outline-offset: 2px;
  }

  /* One line, one tap. 1.2 line-height on 16px inside 0.9rem of padding is
     48px exactly, which is why there is no vertical centring to do. */
  li {
    display: block;
    min-height: 48px;
    padding: 0.9rem 1rem;
    overflow: hidden;
    line-height: 1.2;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .nav-scrim {
    display: block;
    position: fixed;
    inset: 0;
    z-index: 9700;
    background: rgba(0, 0, 0, 0.45);
    opacity: 0;
    visibility: hidden;
    transition: opacity 200ms ease-out, visibility 0s linear 200ms;
  }

  .nav-scrim.nav-scrim-open {
    opacity: 1;
    visibility: visible;
    transition: opacity 200ms ease-out, visibility 0s;
  }
}

/* The hamburger keeps the look it had as a span; these rules only undo the
   blanket `button` rule above and give it a 44px target. */
.nav-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  min-width: 44px;
  min-height: 44px;
  max-width: none;
  max-height: none;
  margin: 0 0.5rem;
  padding: 0;
  border: 0;
  border-radius: 0.25rem;
  background: none #d1d5db;
  color: #0c4a6e;
  /* The blanket `button` rule in this component sets `font-family: Montserrat`
     at a specificity the global `.material-symbols-outlined` class cannot
     beat, so a button carrying an icon name renders the word instead of the
     glyph. Naming the face here is what keeps it an icon. */
  font-size: 1.875rem;
  line-height: 1;
  cursor: pointer;
}

.nav-toggle:hover {
  color: #166534;
}

.nav-toggle:focus-visible {
  outline: 2px solid #097021;
  outline-offset: 2px;
}

@media (prefers-reduced-motion: reduce) {
  nav,
  nav.nav-open,
  .nav-scrim,
  .nav-scrim.nav-scrim-open {
    transition: none;
  }
}
</style>

<style>
/* Deliberately not scoped: the lock belongs on <body>, which no scoped rule
   can reach. `overflow` on the body still governs the viewport while <html>
   is `visible`, so this is the whole lock — and removing the class is the
   whole release. */
body.sa-nav-locked {
  overflow: hidden;
}
</style>
